// Helpers for the "Update available" banner gating in App.tsx.
//
// A version string baked into the SPA bundle by CI is one of:
//   - a release tag like `v0.0.83` or `0.0.83`
//   - a 7-40 char hex commit SHA like `5bfb3dc9` (when the build wasn't
//     triggered by a tag — typical on dev/test branch pipelines)
//
// The two shapes can't be meaningfully compared with each other. If the
// SPA bundle was stamped with a SHA but the server reports a tag (or
// vice versa), the SPA is in a build-pipeline mismatch — refreshing
// the page will not reconcile them because the bundle's stamp can't
// change without a rebuild. Showing an "update available" banner in
// that state turns into an infinite loop. The web client suppresses
// the banner and emits telemetry instead so operators can observe how
// often the CI image-tag collision is hitting users.

const SHA_RE = /^[0-9a-f]{7,40}$/i;
const TAG_RE = /^v?\d+(\.\d+)+/i;

export function isShaLikeVersion(value: string): boolean {
  return SHA_RE.test(value);
}

export function isTagLikeVersion(value: string): boolean {
  return TAG_RE.test(value);
}

/** True when the two version strings come from incompatible shapes
 *  (one looks like a SHA, the other like a release tag). They cannot
 *  be meaningfully ordered, and pretending one is "newer" than the
 *  other would loop the update-available banner on every reload. */
export function isVersionShapeMismatch(a: string, b: string): boolean {
  return (isShaLikeVersion(a) && isTagLikeVersion(b))
    || (isTagLikeVersion(a) && isShaLikeVersion(b));
}
